import React from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import { ClientId as styles } from 'legacy/css-modules';
import { getClientId } from 'selectors/report-data';

export const ClientId = ({ className }) => {
  const clientId = useSelector(getClientId);
  return (
    <div
      className={classNames(styles.ClientId, className)}
      data-hc-name="client-id"
    >
      <div className={styles.Label} data-hc-name="client-id-label">
        Client File ID:
      </div>
      <div data-hc-name="client-id-value">{clientId || '--'}</div>
    </div>
  );
};
